/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import {
  loadFormData,
  changeFieldName,
  changeFieldGender,
  changeFieldBirthDate,
  changeFieldBirthMonth,
  changeFieldBirthYear,
  changeFieldCityGeonameId,
  changeFieldTimeZone,
  changeFieldConsentToAdultContent,
  selectFieldName,
  selectFieldGender,
  selectFieldBirthDate,
  selectFieldBirthMonth,
  selectFieldBirthYear,
  selectCityGeonameItemSelected,
  selectFieldTimeZone,
  selectFieldConsentToAdultContent,
  setCityGeonameItemSelected,
  sendForm,
  selectRequestState
} from 'mt-react-common/modules/users/common/reducers/forms/anketaForm';

import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { yearsArr, getDaysInMonth } from 'mt-react-common/utils/otherHelpers';
import DefaultSelect from '../../../components/Common/Inputs/DefaultSelect';
import SearchSelect from '../../../components/Common/Inputs/SearchSelect';
import LocationSearchAjaxSelect from './inputs/LocationSearchAjaxSelect';
import ButtonConfirmPopUp from '../../../components/Common/Buttons/ButtonConfirmPopUp';
import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';

const anketaFormRN = 'usersModule.forms.anketaForm';

class UserAnketaForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      yearsSelectItems: yearsArr(2000, 1910),
      daysSelectItems: getDaysInMonth(1, 2018)
    };
  }

  componentDidMount() {
    this.props.loadFormData();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.fieldBirthYear !== prevProps.fieldBirthYear ||
      this.props.fieldBirthMonth !== prevProps.fieldBirthMonth
    ) {
      // eslint-disable-next-line no-empty
      if (this.props.fieldBirthYear && prevProps.fieldBirthMonth) {
      }
    }
  }

  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block">{fieldErrors[0].message}</small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <div style={{ minHeight: '700px' }}>
        <div className="panel panel-default panel-heading_padding-large panel-body_bg-sub panel-footer_padding-large">
          <div className="panel-heading text-center">
            <h1 className="panel-title">
              <i className="fa fa-user-circle-o" /> {t('Анкета пользователя')}
            </h1>
          </div>
          <form>
            {this.props.requestStatusData.hasInProgress ? (
              <OpacityPreLoader />
            ) : null}
            <div className="panel-body">
              <div
                className={`form-group ${
                  hasError(this.props.fieldName.errors) ? 'has-error' : ''
                }`}
              >
                <label className="control-label" htmlFor="inputName">
                  {t('Имя')}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inputName"
                  placeholder={t('Имя')}
                  value={this.props.fieldName.value}
                  onChange={e => {
                    this.props.changeFieldName(e.target.value);
                  }}
                />
                {errorDesc(this.props.fieldName.errors)}
              </div>
              <div className="form-group">
                <label className="control-label" htmlFor={'0'}>
                  {t('Пол')}
                </label>
                <DefaultSelect
                  selectArrItems={this.props.userGanders.map(value => ({
                    value: value.id,
                    title: value.title
                  }))}
                  value={this.props.fieldGender.value}
                  handleChangeValue={value => {
                    this.props.changeFieldGender(value);
                  }}
                />
              </div>
              <div className="form-group">
                <label className="control-label" htmlFor={'0'}>
                  {t('Дата рождения')}:
                </label>
                <div className="row">
                  <div className="col-xs-8">
                    <DefaultSelect
                      selectArrItems={this.state.daysSelectItems.map(value => ({
                        value,
                        title: value.toString()
                      }))}
                      value={this.props.fieldBirthDate.value}
                      handleChangeValue={value => {
                        this.props.changeFieldBirthDate(value);
                      }}
                      placeholder={t('День')}
                    />
                  </div>
                  <div className="col-xs-8">
                    <DefaultSelect
                      selectArrItems={Object.keys(this.props.months).map(
                        key => ({
                          value: key,
                          title: this.props.months[key]
                        })
                      )}
                      value={this.props.fieldBirthMonth.value}
                      handleChangeValue={value => {
                        this.props.changeFieldBirthMonth(value);
                      }}
                      placeholder={t('Месяц')}
                    />
                  </div>
                  <div className="col-xs-8">
                    <DefaultSelect
                      selectArrItems={this.state.yearsSelectItems.map(
                        value => ({
                          value,
                          title: value.toString()
                        })
                      )}
                      value={this.props.fieldBirthYear.value}
                      handleChangeValue={value => {
                        this.props.changeFieldBirthYear(value);
                      }}
                      placeholder={t('Год')}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label className="control-label" htmlFor={'0'}>
                  {t('Местоположение')}
                </label>
                <LocationSearchAjaxSelect
                  selectArrItems={Object.keys(this.props.timeZones).map(
                    key => ({
                      id: key,
                      title: this.props.timeZones[key]
                    })
                  )}
                  selectedValue={this.props.cityGeonameItemSelected}
                  handleChangeValue={obj => {
                    console.log(obj);
                    this.props.setCityGeonameItemSelected(obj);
                    this.props.changeFieldCityGeonameId(obj.value);
                    this.props.changeFieldTimeZone(obj.timeZone);
                  }}
                  placeholder={t('Местоположение')}
                />
              </div>
              <div className="form-group">
                <label className="control-label" htmlFor={'0'}>
                  {t('Часовой пояс')}
                </label>
                <SearchSelect
                  selectArrItems={Object.keys(this.props.timeZones).map(
                    key => ({
                      id: key,
                      title: this.props.timeZones[key]
                    })
                  )}
                  value={this.props.fieldTimeZone.value}
                  handleChangeValue={value => {
                    this.props.changeFieldTimeZone(value);
                  }}
                  placeholder={t('Часовой пояс')}
                />
              </div>
              <div className="form-group">
                <label className="control-label" htmlFor={'0'}>
                  {t('Задания 18+')}
                </label>
                <DefaultSelect
                  selectArrItems={[
                    {
                      value: 0,
                      title: t('Скрывать задания 18+')
                    },
                    {
                      value: 1,
                      title: t('Показывать задания 18+')
                    }
                  ]}
                  selectTitleNullValue={null}
                  value={this.props.fieldConsentToAdultContent.value}
                  handleChangeValue={value => {
                    this.props.changeFieldConsentToAdultContent(value);
                  }}
                />
              </div>
            </div>
            <div className="panel-footer">
              <ButtonConfirmPopUp
                id={'confirmUpdateUserAnketaForm'}
                handleConfirmSuccess={() => this.props.sendForm()}
              >
                <div className={'btn-toolbar'}>
                  <button type="button" className={'btn btn-primary'}>
                    {t('Сохранить')}
                  </button>
                </div>
              </ButtonConfirmPopUp>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

UserAnketaForm.propTypes = {
  // IN PROPS
  // eslint-disable-next-line react/no-unused-prop-types
  userId: PropTypes.string.isRequired,

  // CONNECT STATE PROPS
  fieldName: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldGender: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldBirthDate: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldBirthMonth: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldBirthYear: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldTimeZone: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldConsentToAdultContent: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  cityGeonameItemSelected: PropTypes.shape({}).isRequired,
  userGanders: PropTypes.arrayOf(PropTypes.shape).isRequired,
  months: PropTypes.shape({}).isRequired,
  timeZones: PropTypes.shape({}).isRequired,
  requestStatusData: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired
  }).isRequired,

  // CONNECT DISPATCH PROPS
  loadFormData: PropTypes.func.isRequired,
  changeFieldName: PropTypes.func.isRequired,
  changeFieldGender: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  changeFieldBirthDate: PropTypes.func.isRequired,
  changeFieldBirthMonth: PropTypes.func.isRequired,
  changeFieldBirthYear: PropTypes.func.isRequired,
  changeFieldCityGeonameId: PropTypes.func.isRequired,
  changeFieldTimeZone: PropTypes.func.isRequired,
  changeFieldConsentToAdultContent: PropTypes.func.isRequired,
  setCityGeonameItemSelected: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  fieldName: selectFieldName(state, anketaFormRN),
  fieldGender: selectFieldGender(state, anketaFormRN),
  fieldBirthDate: selectFieldBirthDate(state, anketaFormRN),
  fieldBirthMonth: selectFieldBirthMonth(state, anketaFormRN),
  fieldBirthYear: selectFieldBirthYear(state, anketaFormRN),
  fieldTimeZone: selectFieldTimeZone(state, anketaFormRN),
  fieldConsentToAdultContent: selectFieldConsentToAdultContent(
    state,
    anketaFormRN
  ),
  cityGeonameItemSelected: selectCityGeonameItemSelected(state, anketaFormRN),
  timeZones: getItemFromRefList(state, 'timeZones'),
  months: getItemFromRefList(state, 'months'),
  userGanders: getItemFromRefList(state, 'userGanders'),
  requestStatusData: selectRequestState(state, anketaFormRN)
});

const mapDispatchToProps = (dispatch, props) => ({
  loadFormData: () => dispatch(loadFormData(anketaFormRN, props.userId)),
  changeFieldName: value => dispatch(changeFieldName(anketaFormRN, value)),
  changeFieldGender: value => dispatch(changeFieldGender(anketaFormRN, value)),
  changeFieldBirthDate: value =>
    dispatch(changeFieldBirthDate(anketaFormRN, value)),
  changeFieldBirthMonth: value =>
    dispatch(changeFieldBirthMonth(anketaFormRN, value)),
  changeFieldBirthYear: value =>
    dispatch(changeFieldBirthYear(anketaFormRN, value)),
  changeFieldCityGeonameId: value =>
    dispatch(changeFieldCityGeonameId(anketaFormRN, value)),
  changeFieldTimeZone: value =>
    dispatch(changeFieldTimeZone(anketaFormRN, value)),
  changeFieldConsentToAdultContent: value =>
    dispatch(changeFieldConsentToAdultContent(anketaFormRN, value)),
  setCityGeonameItemSelected: value =>
    dispatch(setCityGeonameItemSelected(anketaFormRN, value)),
  sendForm: () => dispatch(sendForm(anketaFormRN, props.userId))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserAnketaForm)
);



// WEBPACK FOOTER //
// ./src/components/UserAccount/UserAnketaForm/UserAnketaForm.js